
class VisualisationsToolboxAbstract {

    typeErrorHelper(VisualisationsToolboxAbstractProps) {
        if (this === VisualisationsToolboxAbstract) {
            // Error Type 2. Abstract methods can not be called directly.
            throw new TypeError("Can not call static abstract method foo.");
        } else if (this[VisualisationsToolboxAbstractProps] === VisualisationsToolboxAbstract[VisualisationsToolboxAbstractProps]) {
            // Error Type 3. The child has not implemented this method.
            throw new TypeError("Please implement static abstract method addParams.");
        } else {
            // Error Type 5. The child has implemented this method but also called `super.addParams()`.
            throw new TypeError("Do not call static abstract method foo from child.");
        }
    }

    static addParams() {
        this.typeErrorHelper("addParams")
    }

    static canProcess() {
        this.typeErrorHelper("canProcess")
    }

    static getVisualisationComponent() {
        this.typeErrorHelper("getVisualisationComponent")
    }

    static getProcessButtonLabel() {
        this.typeErrorHelper("getProcessButtonLabel")
    }

    static getBlockParameters() {
        this.typeErrorHelper("getBlockParameters")
    }
}

export default VisualisationsToolboxAbstract;



// WEBPACK FOOTER //
// ./src/scenes/analysis/lib/VisualisationsToolboxAbstract.js